export const environment = {
    production: true,
    apiUrl: 'https://api.equityisdynamic.com',
    equityIsDynamicUrl: '#'
};
